import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const ConductorFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)

  const [conductores, setConductores] = React.useState([])
  const [mostrarModalCrud, setMostrarModalCrud] = React.useState(false)

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.CONDUCTOR)
      .then(({ data }) => setConductores(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  const onSuccess = React.useCallback(async () => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.CONDUCTOR).then(({ data }) => {
      setConductores(data)
    })
    setMostrarModalCrud(false)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='CONDUCTOR' htmlFor='select-_idConductor' md={3} alignRightAt='md' />
        <Col md={9}>
          <Form.InputGroup>
            <Field name='_idConductor'>
              {({ field }) => (
                <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-_idConductor'>
                  <option value=''>Seleccionar</option>
                  {conductores.map((val, key) => (
                    <option key={key} value={val._id}>
                      {val.nombre}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarModalCrud(true)}>+</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarModalCrud && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={e => setMostrarModalCrud(false)}
          show={mostrarModalCrud}
          modalData={{}}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.CONDUCTOR}
        />
      )}
    </>
  )
}

export default React.memo(ConductorFormGroup)
